// Central test IDs for Ashwin Kalra personal branding site.
export const NAV = {
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkExperience: "nav-link-experience",
  linkSkills: "nav-link-skills",
  linkContact: "nav-link-contact",
  openChat: "nav-open-chat",
};

export const HERO = {
  root: "hero-section",
  askInput: "hero-ask-input",
  askBtn: "hero-ask-btn",
  ctaContact: "hero-cta-contact",
};

export const ABOUT = {
  root: "about-section",
};

export const EXP = {
  root: "experience-section",
  item: (i) => `exp-item-${i}`,
};

export const SKILLS = {
  root: "skills-section",
};

export const CONTACT = {
  root: "contact-section",
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const CHAT = {
  window: "chat-window",
  toggle: "chat-toggle",
  input: "chat-input",
  send: "chat-send",
  close: "chat-close",
  message: (i) => `chat-msg-${i}`,
  suggestion: (i) => `chat-suggestion-${i}`,
};
